import React from 'react';
import { LockIcon, ZapIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { DECO_STACK, FLAVORS, PRICE, STUFFED_IMAGE } from './salesData';
const TRUST_ICONS = [LockIcon, ZapIcon, SmartphoneIcon, ShieldCheckIcon];
const TRUST_LABELS = ['Pago seguro', 'Acceso inmediato', 'Producto digital', 'Garantía de 7 días'];

/**
 * CIERRE. La última impresión vuelve al deseo inicial: la cookie abierta,
 * el precio y el CTA.
 */
export function FinalCta() {
  const closingFlavors = FLAVORS.slice(1, 4);
  return <section className="overflow-hidden bg-ivory py-14 sm:py-24" aria-labelledby="final-title" data-id="element-144" data-mp="1ec7m5kdcfo6l">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-145" data-mp="1t514renwwkfh">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-146" data-mp="1o56bj4gnzir9">
          <div className="relative order-2 lg:order-1" data-id="element-147" data-mp="222uw0b6tknvs">
            <img src={STUFFED_IMAGE} alt="New York Cookie gruesa partida al medio con el relleno cremoso a la vista." loading="lazy" decoding="async" className="aspect-[4/3] w-full rounded-5xl object-cover shadow-bakery" data-id="element-148" data-mp="221jpi3lzp20z" />
            <img src={DECO_STACK} alt="" aria-hidden loading="lazy" style={{
            ['--drift-rot' as string]: '6deg'
          }} className="animate-drift absolute -bottom-5 -right-3 h-24 w-24 rounded-full object-cover shadow-bakery sm:h-32 sm:w-32" data-id="element-149" data-mp="s6ijj6dgz2jy" />
          </div>

          <div className="order-1 text-center lg:order-2 lg:text-left" data-id="element-150" data-mp="1b2i43w44b3ti">
            <p className="inline-flex items-center gap-2 rounded-full bg-caramel-pale px-3 py-1.5 font-sans text-[0.56rem] font-bold uppercase tracking-editorial text-[#F47A2A] sm:text-[0.62rem]" data-id="element-151" data-mp="1fujq49r388wq">
              <span className="h-1.5 w-1.5 rounded-full bg-[#F47A2A]" aria-hidden data-id="element-152" data-mp="1psppokpf92yf" />
              Último paso
            </p>
            <h2 id="final-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.6rem]" data-id="element-153" data-mp="1tv2un6wcgwu5">
              Tu próxima cookie puede empezar hoy
            </h2>
            <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-154" data-mp="3lxf9bjbdiq35">
              Tené 100 recetas y 5 recursos complementarios para empezar a preparar, experimentar y
              construir un catálogo lleno de sabores irresistibles.
            </p>

            <div className="mt-7 inline-flex flex-col items-center gap-2 rounded-5xl bg-cream px-7 py-6 shadow-bakery-sm lg:items-start" data-id="element-155" data-mp="dehfnhlln8ja">
              <p className="font-display font-display-black text-[2.6rem] leading-none tabular-nums text-charcoal sm:text-[3.2rem]" data-id="element-156" data-mp="8j244wb2doq1">
                <span className="align-top font-display text-base font-bold text-[#F47A2A] sm:text-lg" data-id="element-157" data-mp="iec5dhtn1s2r">
                  {PRICE.currency}
                </span>
                {PRICE.current}
              </p>
              <p className="font-sans text-[0.72rem] font-bold uppercase tracking-[0.14em] text-charcoal-mid" data-id="element-158" data-mp="2k7a6s21hdszb">
                Pago único
              </p>
            </div>

            <div className="mt-7" data-id="element-159" data-mp="2e3neu21g1qoe">
              <CTAButton label="Quiero empezar ahora" size="lg" className="w-full lg:w-auto" data-id="element-160" data-mp="2e2lsh1ez9hrd" />
              <p className="mt-4 font-sans text-[0.74rem] leading-relaxed text-charcoal-mid" data-id="element-161" data-mp="20bfiuchzi3qr">
                {PRICE.fx}
              </p>
            </div>
          </div>
        </div>

        {/* Cierre: el producto, no el texto. */}
        <ul className="mt-12 grid grid-cols-3 gap-3 sm:gap-5" data-id="element-162" data-mp="1qgfcnszbaxql">
          {closingFlavors.map(flavor => <li key={flavor.id} data-id="element-163" data-mp="1vb1dx3boj9wy">
              <img src={flavor.image} alt={flavor.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-4xl object-cover shadow-bakery-sm" data-id="element-164" data-mp="1heee8ssce5nc" />
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-165" data-mp="3gr0e3fayxgcx">
          {TRUST_LABELS.map((label, index) => {
          const Icon = TRUST_ICONS[index];
          return <li key={label} className="flex items-center gap-1.5 font-sans text-[0.74rem] font-semibold text-charcoal-mid" data-id="element-166" data-mp="1bqft3dm04xa6" data-mpi={index}>
                <Icon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-167" data-mp="12ozs1wh2u7im" /> {label}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}